<template>
  <div class="flex justify-center">
    <Card class="generic-error-card" :customClasses="customCardClasses">
      <OopsIllustration class="mx-auto" />
      <h2 class="text-h3 text-center mt-16">{{ title }}</h2>
      <p class="body-1 text-center mt-8">
        <slot>
          There was an error loading this page. Refresh the page to try again or
          <a class="link-secondary underline" href="https://support.sittercity.com/hc/en-us/requests/new" target="_blank"
            >contact us</a
          >
          if the issue continues.
        </slot>
      </p>
      <Button :value="buttonValue" variant="primary" size="medium" class="w-full mt-16" :href="buttonHref" @click="handleClick" />
    </Card>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import Card from '../card/Card.vue';
import OopsIllustration from '../../graphics/illustrations/OopsIllustration.vue';
import Button from '../button/Button.vue';

export default Vue.extend({
  name: 'GenericError',
  components: {
    Card,
    OopsIllustration,
    Button,
  },
  props: {
    customCardClasses: {
      type: String,
      default: 'max-w-488 p-32',
    },
    title: {
      type: String,
      default: 'Something went wrong',
    },
    buttonValue: {
      type: String,
      default: 'Try again',
    },
    buttonHref: {
      type: String,
      default: '',
    },
  },
  methods: {
    handleClick() {
      if (this.buttonHref) return;

      if (this.$listeners.errorCtaClick) {
        this.$emit('errorCtaClick');
      } else {
        this.reloadPage();
      }
    },
    reloadPage() {
      window.location.reload();
    },
  },
});
</script>

<style lang="scss" scoped>
.generic-error-card {
  @media (max-width: 640px) {
    background-color: #fbfbfb;
    box-shadow: none !important;
  }
}
</style>
